// eslint-disable-next-line import/no-cycle
import Lister from './lister';

const contragent = {
  lister: Lister,
  selector: Lister,
};

export default contragent;
